<template>
  <div class="submitted-view">
    <!-- Top bar navigation -->
    <header class="app navigation" style="flex: 0; background-color: var(--msag-color); padding: 10px; position: sticky; top:0; z-index: 10;">
      <v-container>
        <v-row justify="space-between" style="align-items: center; padding-bottom: 5px;">
          <div style="margin-right:10px;">
            <v-row justify="space-between" style="align-items: center;">
              <v-col style="flex:0;">
                <div style="background-color:white; padding: 10px; border-radius: 10px; height: 50px; width: 50px;">
                  <img src="@/assets/Maklersprechstunde-Logo.png" alt="Square Image" style="width: 30px; height: 30px;"/>
                </div>
              </v-col>
              <v-col style="flex:1; padding: 0px; margin: 0px;">
                <h1 style="color: white; text-align: left;">Portalpreise.com</h1>
              </v-col>

              <router-link to="/">
                <a class="addButton" style="margin: 5px 10px;">
                  Zur Karte
                </a>
              </router-link>
            </v-row>
          </div>
        </v-row>
      </v-container>
    </header>

    <v-container style="max-width: 720px; padding-bottom: 40px;">
      <v-card class="result-card" style="margin-top: 20px;">
        <FormSteps :current="2" />

        <div class="result-content">
          <div class="result-icon-circle">
            <svg width="44" height="44" viewBox="0 0 24 24">
              <path fill="#237AFD" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/>
            </svg>
          </div>
          <h2 class="title-text">Bitte bestätigen Sie Ihre E-Mail</h2>
          <p>
            Wir haben Ihnen
            <template v-if="email">eine E-Mail an <b>{{ email }}</b></template>
            <template v-else>eine Bestätigungs-E-Mail</template>
            gesendet.<br>
            Klicken Sie auf den Link in der E-Mail, um Ihren Eintrag zu verifizieren.
          </p>
          <p class="result-note">
            Erst nach der Bestätigung wird Ihr Eintrag veröffentlicht und auf der
            Portalpreise-Karte angezeigt. Keine E-Mail erhalten? Werfen Sie bitte
            auch einen Blick in Ihren Spam-Ordner.
          </p>

          <router-link to="/">
            <a class="addButtonBig" style="display: inline-block; margin-top: 8px;">
              Zur Karte
            </a>
          </router-link>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import FormSteps from "@/components/FormSteps.vue";

export default {
  name: "SubmittedView",

  components: {
    FormSteps,
  },
  computed: {
    email() {
      return this.$route.query.email || null;
    },
  },
};
</script>
<style lang="scss">
.submitted-view {
  min-height: 100vh;
  background-color: #f5f5f5;

  .result-card {
    border-radius: 16px !important;
    padding: calc(1rem + 0.5vw + 0.5vh);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08) !important;
  }

  .result-content {
    text-align: center;
    margin-top: 28px;

    p {
      margin: 12px auto 0px auto;
      max-width: 480px;
    }
  }

  .result-icon-circle {
    width: 80px;
    height: 80px;
    margin: 0 auto 16px auto;
    border-radius: 50%;
    background-color: #eaf1fb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-note {
    color: var(--secondaryfont-color);
    font-size: calc(0.4rem + 0.85vmin);
    margin-bottom: 16px !important;
  }
}
</style>
